import { render } from "./ExpenseReceiptsKpiCard.vue?vue&type=template&id=9fc35b40&scoped=true"
import script from "./ExpenseReceiptsKpiCard.vue?vue&type=script&lang=js"
export * from "./ExpenseReceiptsKpiCard.vue?vue&type=script&lang=js"

import "./ExpenseReceiptsKpiCard.vue?vue&type=style&index=0&id=9fc35b40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fc35b40"]])

export default __exports__